import React, { createContext, useState, useContext, useEffect } from "react";
import translations from "../translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(null); // Изменено с "en" на null

  useEffect(() => {
    const savedLanguage = localStorage.getItem("lang") || "en"; // Загружаем из localStorage
    setLanguage(savedLanguage);
  }, []);

  useEffect(() => {
    if (language) {
      localStorage.setItem("lang", language);
    }
  }, [language]);

  const toggleLanguage = (selectedLanguage) => {
    if (selectedLanguage !== language) {
      setLanguage(selectedLanguage);
    }
  };

  if (!language) return null; // Ждем загрузки языка перед рендерингом

  return (
    <LanguageContext.Provider
      value={{ language, toggleLanguage, translations: translations[language] }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
